var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("6 、外购资产，必须先通过（　）进行核算，然后再进行转固处理。")])])
}]

export { render, staticRenderFns }